import { Pager, PagerProps } from '@progress/kendo-react-data-tools';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { resources } from '../../apps/benefit/resources/resources';
import useBreakpoints from '../hooks/useBreakpoints';
import Dropdown from './Dropdown';

export const GridPager = (props: PagerProps) => {
  const { t: translate } = useTranslation();
  const { isMobile } = useBreakpoints();
  const { onPageChange, skip, take, pageSizes, pageSizeValue, total } = props;

  const handleChangeSize = (newSize: number) => {
    if (onPageChange) {
      const pageChangeEvent = {
        skip,
        take: newSize,
        syntheticEvent: { target: { value: newSize } },
        nativeEvent: undefined,
        targetEvent: undefined,
      };

      onPageChange(pageChangeEvent as any);
    }
  };

  if (!total) return null;

  const pageSizeOptions =
    pageSizes?.map(item => ({
      value: item,
      label: `${item} ${translate(resources.onPage)}`,
    })) || [];

  const selectedPageSize = pageSizeOptions.find(x => x.value === pageSizeValue);

  return (
    <div className={'k-grid-pager custom-pager'}>
      <div className="custom-pager-display">
        {!!pageSizes && (
          <>
            <span>{translate(resources.display)}</span>
            <Dropdown
              style={{
                width: 'auto',
              }}
              onChange={e => {
                handleChangeSize(e.value?.value);
              }}
              data={pageSizeOptions}
              textField="label"
              dataItemKey="value"
              value={selectedPageSize}
              controlClassName="filter-dropdown"
              popupClassName={'filter-dropdown-popup custom-pager-dropdown'}
            />
          </>
        )}
      </div>
      <div className="custom-pager-nav">
        {total > take && (
          <Pager
            {..._.omit(props, [
              'className',
              'pageSizes',
              'pageSizeValue',
              'responsive',
            ])}
            responsive={false}
            buttonCount={isMobile ? 3 : props.buttonCount}
          />
        )}
      </div>
    </div>
  );
};
